<div id="siteWrap" v-bind:class="[browserName, osClass, deviceClass, screenClass, scriptClass]">
  <Gdpr v-if="cookieAuth" />
  <NavBar ref="navbar" />
  <router-view/>

  <Footer />
</div>
